import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const CloseTicketIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };
  return (
    <svg
      width={finalSize?.width ?? "24"}
      height={finalSize?.height ?? "24"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4835 17.2918H9.09179C8.75012 17.2918 8.46679 17.0085 8.46679 16.6668C8.46679 16.3252 8.75012 16.0418 9.09179 16.0418H14.4835C17.0335 16.0418 17.6335 15.6252 17.7001 13.3585C16.6001 13.0752 15.7835 12.0752 15.7835 10.8918C15.7835 9.70018 16.6001 8.69185 17.7085 8.40851V8.19185C17.7085 5.45018 17.2251 4.96685 14.4835 4.96685H9.79179V10.0002C9.79179 10.3418 9.50845 10.6252 9.16679 10.6252C8.82512 10.6252 8.54179 10.3418 8.54179 10.0002V4.34185C8.54179 4.00018 8.82512 3.71685 9.16679 3.71685H14.4835C17.9168 3.71685 18.9585 4.75851 18.9585 8.19185V8.95851C18.9585 9.30018 18.6751 9.58351 18.3335 9.58351C17.6168 9.58351 17.0335 10.1668 17.0335 10.8918C17.0335 11.6085 17.6168 12.1918 18.3335 12.1918C18.6751 12.1918 18.9585 12.4752 18.9585 12.8168C18.9585 16.2502 17.9168 17.2918 14.4835 17.2918Z"
        fill="#FFA39E"
      />
      <path
        d="M9.16679 17.2918H6.85845C5.17512 17.2918 4.30845 16.0252 3.51679 14.1252L3.35845 13.7418C3.30012 13.5918 3.30012 13.4168 3.36679 13.2668C3.43345 13.1168 3.55845 12.9918 3.70845 12.9335C4.04179 12.8002 4.30012 12.5418 4.44179 12.2168C4.58345 11.8835 4.58345 11.5168 4.44179 11.1835C4.16679 10.4835 3.37512 10.1585 2.67512 10.4335C2.51679 10.5002 2.35012 10.4918 2.19179 10.4252C2.04179 10.3585 1.91679 10.2335 1.85845 10.0835L1.71679 9.72518C0.383453 6.48351 0.966786 5.09185 4.20845 3.75018L6.40845 2.85018C6.72512 2.71685 7.09179 2.87518 7.22512 3.19185L9.75012 9.30851C9.78345 9.38351 9.80012 9.46685 9.80012 9.55018V11.6668C9.80012 12.0085 9.51679 12.2918 9.17512 12.2918C8.83345 12.2918 8.55012 12.0085 8.55012 11.6668V9.66685L6.30012 4.24185L4.68345 4.90851C2.11679 5.96685 1.80845 6.61685 2.81679 9.11685C3.97512 8.95018 5.14179 9.57518 5.60012 10.7002C5.86679 11.3418 5.86679 12.0502 5.59179 12.6918C5.40845 13.1335 5.10845 13.5085 4.72512 13.7835C5.52512 15.6668 6.10845 16.0418 6.85012 16.0418H8.53345V14.1668C8.53345 13.8252 8.81679 13.5418 9.15845 13.5418C9.50012 13.5418 9.78345 13.8252 9.78345 14.1668V16.6668C9.79179 17.0085 9.50845 17.2918 9.16679 17.2918Z"
        fill="#FFA39E"
      />
      <path
        d="M6.80845 17.2918H6.66679C6.32512 17.2918 6.04179 17.0085 6.04179 16.6668C6.04179 16.3252 6.32512 16.0418 6.66679 16.0418H6.80845C7.15012 16.0418 7.43345 16.3252 7.43345 16.6668C7.43345 17.0085 7.15012 17.2918 6.80845 17.2918Z"
        fill="#FFA39E"
      />
    </svg>
  );
};
const CloseTicketIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={CloseTicketIconSVG}
      style={{
        // color: color || themeDefault?.info?.newConfig?.color,

        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default CloseTicketIcon;
